var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSessions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21C5.33696 21 4.70107 20.7366 4.23223 20.2678C3.76339 19.7989 3.5 19.163 3.5 18.5V1.5C3.5 1.10218 3.34196 0.720644 3.06066 0.43934C2.77936 0.158035 2.39782 0 2 0C1.60218 0 1.22064 0.158035 0.93934 0.43934C0.658035 0.720644 0.5 1.10218 0.5 1.5V18.5C0.5 19.9587 1.07946 21.3576 2.11091 22.3891C3.14236 23.4205 4.54131 24 6 24H23C23.3978 24 23.7794 23.842 24.0607 23.5607C24.342 23.2794 24.5 22.8978 24.5 22.5C24.5 22.1022 24.342 21.7206 24.0607 21.4393C23.7794 21.158 23.3978 21 23 21H6Z",
    fill: "#039590"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18C20.3978 18 20.7794 17.842 21.0607 17.5607C21.342 17.2794 21.5 16.8978 21.5 16.5V10.5C21.5 10.1022 21.342 9.72064 21.0607 9.43934C20.7794 9.15804 20.3978 9 20 9C19.6022 9 19.2206 9.15804 18.9393 9.43934C18.658 9.72064 18.5 10.1022 18.5 10.5V16.5C18.5 16.8978 18.658 17.2794 18.9393 17.5607C19.2206 17.842 19.6022 18 20 18Z",
    fill: "#039590"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18C8.39782 18 8.77936 17.842 9.06066 17.5607C9.34196 17.2794 9.5 16.8978 9.5 16.5V10.5C9.5 10.1022 9.34196 9.72064 9.06066 9.43934C8.77936 9.15804 8.39782 9 8 9C7.60218 9 7.22064 9.15804 6.93934 9.43934C6.65804 9.72064 6.5 10.1022 6.5 10.5V16.5C6.5 16.8978 6.65804 17.2794 6.93934 17.5607C7.22064 17.842 7.60218 18 8 18Z",
    fill: "#039590"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18C14.3978 18 14.7794 17.842 15.0607 17.5607C15.342 17.2794 15.5 16.8978 15.5 16.5V5.5C15.5 5.10218 15.342 4.72064 15.0607 4.43934C14.7794 4.15804 14.3978 4 14 4C13.6022 4 13.2206 4.15804 12.9393 4.43934C12.658 4.72064 12.5 5.10218 12.5 5.5V16.5C12.5 16.8978 12.658 17.2794 12.9393 17.5607C13.2206 17.842 13.6022 18 14 18Z",
    fill: "#039590"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessions);
export default __webpack_public_path__ + "static/media/sessions.230077f1cfa11df40fa7bd63d63053df.svg";
export { ForwardRef as ReactComponent };